export enum PostType {
    Standard = 1,
    TimeSensitive = 2,
    Critical = 3,
    QuickNotice = 4,
    QuickEvent = 5
}
